import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography, Description, LazyImg } from '@quikr/ui';
import config from '../../../../../config';
const { IMAGE_CDN_DOMAIN } = config;

const HeaderSection = styled.ul`
  background: ${({ theme }) => theme.colors.Neutral[600]};
  border: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  border-radius: 4px;
  padding: 16px 0px;
  @media (max-width: 767px) {
    overflow-x: scroll;
    border-radius: 0;
    margin-left: -12px;
    margin-right: -12px;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const WrapProperty = styled.div`
  border-right: 1px solid ${({ theme }) => theme.colors.Neutral[100]};
  padding-left: 16px;
  &:last-child {
    border-right: none;
  }
  @media (min-width: 767px) {
    min-width: calc(100% / 3);
  }
  @media (max-width: 767px) {
    padding-right: 16px;
    white-space: pre;
  }
`;

const Span = styled(Typography)`
  margin-bottom: 5px;
  color: ${({ theme }) => theme.colors.TextBeta};
`;

const ValueDiv = styled(Typography)`
  color: ${({ theme }) => theme.colors.TextAlpha};
  &:first-letter {
    text-transform: uppercase;
  }
`;

const ImgWrap = styled.div`
  margin: 24px 0px 0px;
`;

const FigureBox = styled.div`
  height: 120px;
  min-width: 180px;
  border: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  @media (min-width: 767px) {
    margin-right: 24px;
  }
`;

const Module = styled.div`
  color: inherit;
  @media (max-width: 767px) {
    margin-top: 16px;
  }
`;

const Desc = styled(Description)`
  margin-top: 8px;
  &:first-of-type {
    padding-top: 0px;
  }
`;

const Title = styled(Typography)`
  color: ${({ theme }) => theme.colors.TextAlpha};
  &:hover {
    color: ${({ theme }) => theme.colors.Primary};
  }
`;

const AboutTemplate = ({ isMobile, data = {} }) => {
  if (!data) return null;
  const { description, properties = [], title, logo, href } = data;
  return (
    <>
      <HeaderSection className="dF">
        {properties.map((each, index) => (
          <WrapProperty tagName="li" className={'dF fdC'} key={index}>
            <Span tagName="span" modifiers="bt2" className="ttC">
              {each.key}
            </Span>
            <ValueDiv tagName="p" modifiers={['bt1', 'bold']}>
              {each.value}
            </ValueDiv>
          </WrapProperty>
        ))}
      </HeaderSection>
      <ImgWrap className={`dF jcSB aiFS ${isMobile && 'fdC'}`}>
        <FigureBox className={`oH dFA jcSA vaT ${isMobile && 'w100'}`}>
          <LazyImg src={`${IMAGE_CDN_DOMAIN}${logo}`} alt="" />
        </FigureBox>
        <Module className="dF fdC">
          <Title tagName="a" target="__blank" href={href} modifiers={['bt1', 'bold']}>
            {title}
          </Title>
          <Desc content={[description]} maxLength={200} modifiers="bt2" />
        </Module>
      </ImgWrap>
    </>
  );
};

AboutTemplate.propTypes = {
  title: PropTypes.string,
  isMobile: PropTypes.bool,
  data: PropTypes.object,
  logo: PropTypes.string,
  href: PropTypes.string
};

export default AboutTemplate;
